import { useState, useEffect } from 'react';
import AuthModal from '../../../components/feature/AuthModal';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState<'signin' | 'signup'>('signin');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSignIn = () => {
    setAuthMode('signin');
    setAuthModalOpen(true);
  };

  const handleGetStarted = () => {
    setAuthMode('signup');
    setAuthModalOpen(true);
  };

  const navigate = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
  };

  return (
    <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-gray-950/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}>
        <nav className="px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between max-w-7xl mx-auto">
            <div className="flex items-center space-x-4 lg:space-x-12">
              <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="flex items-center gap-2">
                <div className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-gradient-to-br from-teal-400 to-cyan-500 rounded-lg relative">
                  <i className="ri-shield-check-line text-lg sm:text-xl text-gray-900"></i>
                  <div className="absolute inset-0 bg-teal-400/20 rounded-lg blur-sm"></div>
                </div>
                <span className="text-xl sm:text-2xl font-bold text-white" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
                  Protect<span className="text-teal-400">Wize</span>
                </span>
              </a>
              <div className="hidden lg:flex items-center space-x-8">
                <a href="#features" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">Features</a>
                <a href="#analytics" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">Analytics</a>
                <a href="#security" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">Security</a>
                <a
                  href="/training"
                  onClick={(e) => { e.preventDefault(); navigate('/training'); }}
                  className="text-teal-400 transition-colors cursor-pointer whitespace-nowrap font-medium"
                >
                  Training
                </a>
                <a
                  href="/consulting"
                  onClick={(e) => { e.preventDefault(); navigate('/consulting'); }}
                  className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Consulting
                </a>
                <a
                  href="/about"
                  onClick={(e) => { e.preventDefault(); navigate('/about'); }}
                  className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  About Us
                </a>
                <a
                  href="/wizeai"
                  onClick={(e) => { e.preventDefault(); navigate('/wizeai'); }}
                  className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  WizeAI
                </a>
              </div>
            </div>
            <div className="flex items-center space-x-2 sm:space-x-4">
              <button
                onClick={handleSignIn}
                className="px-3 sm:px-5 py-2 sm:py-2.5 text-sm sm:text-base text-gray-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                Sign In
              </button>
              <button
                onClick={handleGetStarted}
                className="px-4 sm:px-6 py-2 sm:py-2.5 text-sm sm:text-base bg-teal-500 text-gray-900 rounded-lg hover:bg-teal-400 transition-colors cursor-pointer whitespace-nowrap font-semibold"
              >
                Get Started
              </button>
            </div>
          </div>
        </nav>
      </header>

      <AuthModal
        isOpen={authModalOpen}
        onClose={() => setAuthModalOpen(false)}
        initialMode={authMode}
      />
    </>
  );
}
